import { combineReducers } from "redux";
import * as types from "./types";
import { USER_SIGNED_OUT } from "../user/types";

const redemptionCodesReducer = (state = {}, action) => {
  switch (action.type) {
    case types.REDEEM_CODE_REQUEST:
      return { ...state, [action.code]: { isRedeeming: true } };
    case types.REDEEM_CODE_SUCCESS:
      return { ...state, [action.code]: { isRedeeming: false, error: false } };
    case types.REDEEM_CODE_FAILURE:
      return {
        ...state,
        [action.code]: { isRedeeming: false, error: action.error }
      };
    default:
      return state;
  }
};

const updatingReducer = (state = false, action) => {
  switch (action.type) {
    case types.UPDATE_LICENSE_REQUEST:
      return true;
    case types.UPDATE_LICENSE_SUCCESS:
      return false;
    case USER_SIGNED_OUT:
      return false;
    default:
      return state;
  }
};

const licenseReducer = combineReducers({
  updating: updatingReducer,
  redemptionCodes: redemptionCodesReducer
});

export default licenseReducer;
